var _path, _path2, _path3;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCalendar = function SvgCalendar(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.833313 4.58331C0.833313 3.43272 1.76605 2.49998 2.91665 2.49998H17.0833C18.2339 2.49998 19.1666 3.43272 19.1666 4.58331V17.0833C19.1666 18.2339 18.2339 19.1666 17.0833 19.1666H2.91665C1.76605 19.1666 0.833313 18.2339 0.833313 17.0833V4.58331ZM2.91665 4.16665C2.68653 4.16665 2.49998 4.35319 2.49998 4.58331V17.0833C2.49998 17.3134 2.68653 17.5 2.91665 17.5H17.0833C17.3134 17.5 17.5 17.3134 17.5 17.0833V4.58331C17.5 4.35319 17.3134 4.16665 17.0833 4.16665H2.91665Z",
    fill: "#0258FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.24998 0.833313C6.71022 0.833313 7.08331 1.20641 7.08331 1.66665V4.99998C7.08331 5.46022 6.71022 5.83331 6.24998 5.83331C5.78974 5.83331 5.41665 5.46022 5.41665 4.99998V1.66665C5.41665 1.20641 5.78974 0.833313 6.24998 0.833313Z",
    fill: "#0258FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.75 0.833313C14.2102 0.833313 14.5833 1.20641 14.5833 1.66665V4.99998C14.5833 5.46022 14.2102 5.83331 13.75 5.83331C13.2897 5.83331 12.9166 5.46022 12.9166 4.99998V1.66665C12.9166 1.20641 13.2897 0.833313 13.75 0.833313Z",
    fill: "#0258FF"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalendar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calendar.07828bb3.svg";
export { ForwardRef as ReactComponent };